var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesodi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kxfnosccwa",
    d: "M0 0.754L25 0.754 25 2.416 0 2.416z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "58ad71kbsc",
    d: "M0 0.747L25 0.747 25 2.408 0 2.408z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB7C",
    d: "M23.368 22.936V2.578H1.632v20.358l10.658.407v2.174c-.662.102-1.171.666-1.171 1.355 0 .759.619 1.373 1.38 1.373.764 0 1.382-.614 1.382-1.373 0-.689-.51-1.253-1.171-1.355v-2.174l10.658-.407zm-10.04 3.936c0 .454-.37.825-.828.825-.457 0-.828-.37-.828-.825 0-.456.37-.825.828-.825.458 0 .829.369.829.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M12.5 10.147c-1.272 0-2.302 1.026-2.302 2.291s1.03 2.291 2.301 2.291c1.271 0 2.302-1.026 2.302-2.29 0-1.266-1.03-2.292-2.302-2.292M7.953 10.147H4.271c-.255 0-.46.205-.46.458v3.666c0 .253.205.458.46.458h3.682c.254 0 .46-.205.46-.458v-3.666c0-.253-.206-.458-.46-.458M17.37 10.28c-.178-.18-.47-.18-.65-.003-.088.087-.137.205-.136.328v3.666c0 .253.206.458.46.458h3.682c.255.002.462-.202.463-.455 0-.123-.048-.242-.136-.328L17.37 10.28z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eq2s47zhlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kxfnosccwa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M24.152 2.416H.847C.38 2.416 0 2.043 0 1.585c0-.458.38-.83.847-.83h23.305c.468 0 .848.372.848.83 0 .458-.38.83-.848.83",
    mask: "url(#eq2s47zhlb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d377kvffid",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#58ad71kbsc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C93D0B",
    d: "M24.152 2.408H.847C.38 2.408 0 2.036 0 1.577c0-.458.38-.83.847-.83h23.305c.468 0 .848.372.848.83 0 .459-.38.831-.848.831",
    mask: "url(#d377kvffid)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesodi);
export default __webpack_public_path__ + "static/media/yesodi.24d116eaa90b98c93a350659a8969260.svg";
export { ForwardRef as ReactComponent };